<script>
import CountrySection from "@/modules/international-operations/components/CountrySection.vue";
import PriceSection from "@/modules/international-operations/components/PriceSection.vue";
import { mapActions } from "vuex";

export default {
  name: "InternationalOperations",
  components: { PriceSection, CountrySection },

  data() {
    return {
      currentCountry: "KGZ",
      isInitialLoad: true,
    };
  },

  methods: {
    ...mapActions({
      loadIncomeBalance: "balance/loadIncomeBalance",
      setCountry: "internationalOperations/setCountry",
    }),

    saveCountryToLocalStorage(country) {
      localStorage.setItem("selectedOperationsCountry", country);
    },

    loadCountryFromLocalStorage() {
      // return localStorage.getItem("selectedOperationsCountry");
      return "KGZ";
    },
  },

  watch: {
    currentCountry(newCountry) {
      this.setCountry(newCountry);
      this.saveCountryToLocalStorage(newCountry);

      // в балансе уже вызывается, поэтому во избежание дублирования запроса - проверка
      if (!this.isInitialLoad) {
        this.loadIncomeBalance(newCountry);
      }
    },
  },

  created() {
    const savedCountry = this.loadCountryFromLocalStorage();
    const initialCountry = savedCountry || "KGZ";

    this.currentCountry = initialCountry;
    this.setCountry(initialCountry);

    this.$nextTick(() => {
      this.isInitialLoad = false;
    });
  },

  beforeDestroy() {
    this.setCountry("RUS");
  },
};
</script>

<template>
  <div class="international-operations">
    <CountrySection v-model="currentCountry" />

    <PriceSection :current-country="currentCountry" />
  </div>
</template>

<style lang="scss" scoped>
.international-operations {
  display: flex;
  flex-direction: column;
  gap: 64px;
}
</style>
